import { render, staticRenderFns } from "./CampaignInfoPopup.vue?vue&type=template&id=6bf1db24&scoped=true&"
import script from "./CampaignInfoPopup.vue?vue&type=script&lang=ts&"
export * from "./CampaignInfoPopup.vue?vue&type=script&lang=ts&"
import style0 from "./CampaignInfoPopup.vue?vue&type=style&index=0&id=6bf1db24&scoped=true&lang=sass&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bf1db24",
  null
  
)

export default component.exports